const getItemUuidsById = ({ allItems, id, langUuid }) => {
	const foundItem = allItems.find(item => item.id === id && item.languageUuid === langUuid);
	return foundItem ? foundItem.uuid : undefined;
};

export default getItemUuidsById;



// WEBPACK FOOTER //
// ./src/helpers/getItemUuidsById.js